<template>
<div class="wrapper">
  <div class="container details">
    <div class="row">
      <div class="col-md-10">
        <h1>Order {{order.id}} </h1>
      </div>
      <div class="col-md-2">
        <p class="stateWrapper"><strong>Status: </strong><span :class="order.state">{{ order.state }}</span></p>
        <div v-if="order.data && order.data.accepted" class="acceptedWrapper">
          <p><strong>Accepterad av</strong></p>
          <ul>
            <li v-for="(acceptedObject, key) in order.data.accepted" :key="key">
              {{acceptedObject.driverName}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <TabView>
      <TabPanel header="Information">
        <div class="row">
          <div class="col-md-3" v-for="schemaField in schema.fields" :key="schemaField.id">
            <label>{{ schemaField.label }}</label>
            <p>{{order.data[schemaField.model]}}</p>
          </div>
        </div>
        <div class="row orderDetailsWrapper">
          <div class="col-md-12">
            <form class="formGeneratorWithColumns">
              <vue-form-generator tag="div" :schema="activeSchema" :model="order.data" />
            </form>
          </div>
      </div>
      </TabPanel>
        <TabPanel v-if="order.data && order.data.orderRows" class="reportedPanel" header="Rapporterat">
        <ActivityTable v-for="orderRow in order.data.orderRows" :activities="orderRow.actions" :orderRow="orderRow" :orderType="order.type" :key="orderRow.id" :isOpen="true" :showTotal="false" />
      </TabPanel>
      <TabPanel v-if="order.data" header="Containerlogg">
        <ContainerLogTable style="margin-bottom: 100px" :orderId="order.id"/>
      </TabPanel>
    </TabView>
  </div>
   <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <SplitButton label="Spara" class="p-button-success" @click="onSave()" :model="saveButtons" icon="pi pi-check"></SplitButton>
        <Button v-if="order.state !== 'makulerad'" label="Kopiera" class="p-button-success" @click="onCopy()" icon="pi pi-file" ></Button>
        <Button v-if="order.state !== 'avslutad'" label="Avsluta" @click="onFinished()"/>
        <Button v-if="order.state === 'avslutad'" class="p-button-danger" label="Arkivera" @click="onArchive(order)"/>
        <Button v-if="order.state!=='makulerad'" label="Makulera" class="p-button-danger" @click="onDelete()"/>
        <!--<Button label="Temp" class="p-button-danger" @click="onSetDefault()" />-->
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
  <Toast position="bottomright" />
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import SplitButton from 'primevue/splitbutton'
import Button from 'primevue/button'
import TabView from 'primevue/tabview'
import DataTable from 'primevue/datatable'
import TabPanel from 'primevue/tabpanel'
import Column from 'primevue/column'
import { bus } from '../../main'
import ActivityTable from '@/components/Activities/ActivityTable'
import ContainerLogTable from '@/components/Activities/ContainerLogTable'
import CreateNewOrderRow from '@/components/Activities/CreateNewOrderRow'
import moment from 'moment'
export default {
  name: 'ContainerOrderDetails',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    'Toast': Toast,
    Dialog,
    Button,
    ActivityTable,
    TabView,
    DataTable,
    CreateNewOrderRow,
    Column,
    TabPanel,
    SplitButton,
    'moment': moment,
    ContainerLogTable
  },
  data () {
    return {
      order: {},
      schema: {},
      activeSchema: {},
      customerName: '',
      dataArray: [],
      display: false,
      editMode: false,
      editedActivity: '',
      opened: [],
      fractions: {},
      saveButtons: [
        {
          label: 'Skicka till lastbil',
          icon: 'pi pi-user',
          command: () => {
            this.onReady()
          }
        }
      ]
    }
  },
  watch: {
    '$route' (to, from) {
      this.init()
    }
  },
  created () {
    bus.$on('removedOrderRow', (id) => {
      this.currentOrder.data.orderRows = this.currentOrder.data.orderRows.filter(function (obj) {
        return obj.id !== id
      })
    })
    bus.$on('addedOrderRow', (orderRow) => {
      this.currentOrder.data.orderRows.push(orderRow)
    })
    bus.$on('addedActivity', (obj, id, activity, action) => {
      if (id === this.currentOrder.data.orderRows[0].id) {
        if (activity.name === 'Avslutad') {
          this.currentOrder.data.orderRows[0].endTime = activity.startTime
          this.currentOrder.data.orderRows[0].state = 'Avslutad'
        }
        this.currentOrder.data.orderRows[0].actions = obj
      }
    })
  },
  async mounted () {
    const data = await this.getOrder()
    this.order = data.order
    this.schema = data.schema
    this.activeInputs()
    this.disabledInputs()
    this.getTrucks()
    this.fractions = await this.getFractions()
    this.getAVC()
  },
  methods: {
    async init () {
      const data = await this.getOrder()
      this.order = data.order
      this.schema = data.schema
      this.activeInputs()
      this.disabledInputs()
      this.getTrucks()
      this.fractions = await this.getFractions()
      this.getAVC()
    },
    async getOrder () {
      let response = await this.$http.get('/api/orders/by-type/container/' + this.$route.params.id)
      return response.data
    },
    addNewRow () {
      this.newOrderRow = {name: '', user: '', startTime: '', endTime: '', amount: '', deliveryPlace: '', comment: '', washPlace: ''}
      this.dialogVisible = true
    },
    open () {
      this.display = true
    },
    onChange (event) {
      if (event.target.value) {
        this.activity = event.target.value
        this.display = true
      }
    },
    activeInputs () {
      if (this.schema) {
        this.activeSchema = Object.assign({}, this.schema)
        this.activeSchema.fields = this.activeSchema.fields.filter((c) => c.activeInDetails)
      }
    },
    disabledInputs () {
      this.schema.fields = this.schema.fields.filter((c) => c.activeInDetails === false)
    },
    getTrucks () {
      var trucksSelect = this.activeSchema.fields.find(field => field.model === 'truck')
      this.$http
        .get('/api/objectdatas/objectgroupid/2')
        .then(response => {
          var trucks = response.data.filter(truck => (truck.objectDescriptionId === 2 || truck.objectDescriptionId === 3))
          trucks.sort(function (a, b) {
            if (a.data.regnbr < b.data.regnbr) { return -1 }
            return 0
          })
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              trucksSelect.values.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr, 'type': trucks[i].ObjectDescription.name})
            }
          }
        })
        .catch(error => console.log(error))
    },
    async getFractions () {
      const response = await this.$http.get('/api/objectdatas/objectdescriptionid/22')
      return response.data.map((el) => ({id: el.id, name: el.data.name}))
    },
    getAVC () {
      var avcSelect = this.activeSchema.fields.find(field => field.model === 'avcs')
      this.$http
        .get('/api/containerorders/getavcs')
        .then(async response => {
          let avcs = response.data
          let standardPlaces = response.data.filter((c) => c.data.inActive !== true && (c.data.type === 'Mellanlagring' || c.data.type === 'Service'))
          let arrStandardPlaces = []
          for (var d = 0; d < standardPlaces.length; d++) {
            let standardPlace = {id: standardPlaces[d].id, address: standardPlaces[d].data.address, name: standardPlaces[d].data.name, type: standardPlaces[d].data.type}
            arrStandardPlaces.push(standardPlace)
          }
          for (var i = 0; i < avcs.length; i++) {
            if (!avcs[i].data.inActive) {
              let arrForbehandlare = []
              let selectedForbehandlare = avcs[i].selectedForbehandlare
              for (var b = 0; b < avcs[i].forbehandlare.length; b++) {
                arrForbehandlare.push({id: avcs[i].forbehandlare[b].id, name: avcs[i].forbehandlare[b].data.name + ' ' + avcs[i].forbehandlare[b].data.address, address: avcs[i].forbehandlare[b].data.address, fractions: avcs[i].forbehandlare[b].data.fraktioner})
                if (selectedForbehandlare === null || selectedForbehandlare === undefined) {
                  selectedForbehandlare = {id: avcs[i].forbehandlare[0].id, name: avcs[i].forbehandlare[0].data.name + ' ' + avcs[i].forbehandlare[0].data.address, address: avcs[i].forbehandlare[0].data.address, fractions: avcs[i].forbehandlare[b].data.fraktioner}
                  if (avcs[i].forbehandlare[b].chosen) {
                    selectedForbehandlare = {id: avcs[i].forbehandlare[b].id, name: avcs[i].forbehandlare[b].data.name + ' ' + avcs[i].forbehandlare[b].data.address, address: avcs[i].forbehandlare[b].data.address, fractions: avcs[i].forbehandlare[b].data.fraktioner}
                  }
                }
              }
              let containers = await this.getContainers(avcs[i].id)
              avcSelect.values.push({'objectId': avcs[i].objectId, 'id': avcs[i].id, 'name': avcs[i].data.name, 'type': avcs[i].data.type, 'city': avcs[i].data.city, 'address': avcs[i].data.address, 'selectedFraction': avcs[i].fraction, 'fractions': this.fractions, 'selectedForbehandlare': selectedForbehandlare, 'forbehandlare': arrForbehandlare, 'containerAmount': 0, notice: avcs[i].notice, 'standardPlaces': arrStandardPlaces, containers: containers, comment: avcs[i].comment, globalComments: []})
            }
          }
        })
        .catch(error => console.log(error))
    },
    async getContainers (id) {
      let containers = await this.$http.get('/api/containercurrlogsByPlace/' + id)
      containers.data = containers.data.filter(function (obj) {
        return obj.container.data.status !== 'Inaktiv'
      })
      return containers.data
    },
    async onSave () {
      var url = '/api/orders/' + this.order.id
      this.$http
        .put(url, {
          order: {
            id: this.order.id,
            state: this.order.state = ['aktiv', 'skickad', 'avslutad'].includes(this.order.state) ? this.order.state : 'uppdaterad',
            data: this.order.data
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Order sparad', life: 3000})
        })
        .catch(error => console.log(error))
    },
    async onReady () {
      if (this.order.state !== 'aktiv' && this.order.state !== 'accepterad') {
        this.order.state = 'skickad'
      }
      var url = '/api/orders/' + this.order.id
      this.$http
        .put(url, {
          order: {
            state: this.order.state,
            data: this.order.data,
            actions: this.activities
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Sparad och skickad till lastbil', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onCopy () {
      let message = 'Vill du kopiera ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var copyOrder = Object.assign({}, this.order)
          let data = copyOrder.data
          delete data['orderRows']
          delete data['accepted']
          var url = '/api/orders'
          this.$http
            .post(url, {
              order: {
                type: 'container',
                state: 'uppdaterad',
                needsAttention: 0,
                data: data
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onDelete () {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/orders/' + this.order.id
          this.state = 'makulerad'
          this.$http
            .put(url, {
              order: {
                id: this.order.id,
                state: 'makulerad',
                data: this.order.data
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onCancel () {
      this.$router.go(-1)
    },
    onFinished () {
      let message = 'Vill du avsluta ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.state = 'avslutad'
          var url = '/api/orders/' + this.order.id
          this.$http
            .put(url, {
              order: {
                state: 'avslutad',
                data: this.order.data
              }
            })
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Order satt som avslutad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on finish')
        })
    },
    onArchive (order) {
      let message = 'Vill du arkivera ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.state = 'arkiverad'
          var url = '/api/orders/' + order.id
          this.$http
            .put(url, {
              order: {
                id: order.id,
                state: 'arkiverad',
                data: order.data
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onSetDefault () {
      var url = '/api/containerlog/setcontainers'
      this.$http
        .post(url)
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Klart', life: 3000})
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/ContainerOrderDetails.vue